

export const ProductsConfig = {
  farmAndRanch: {
    block_1: {
      rightPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/traktor.svg`,
      rightPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/traktor.png`,
      leftPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house.svg`,
      leftPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house.png`,
      className: 'farm_and_ranch',
      widthTitle: 'auto',
      widthUnderTitle: '559px',
      title: 'Farm and Ranch Insurance',
      undertitle: 'RVOS Insurance was founded by farmers and ranchers who came together to help each other in their time of need. Since then, we have protected hundreds of thousands of Texas farmers and ranchers. With over 120 years of experience, we understand their unique needs.'
    },
    block_2: {
      title: 'What is included?',
      undertitle: 'Included Farm & Ranch Insurance coverages',
      block2_1: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/house.svg`,
          title: 'Dwelling',
          text: 'Provides protection for your home.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/other-structures.svg`,
          title: 'Other Structures',
          text: 'Protection for stand-alone structures on your property, such as sheds, carports, and fences.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/personal-property.svg`,
          title: 'Personal Property',
          text: 'Protects the personal items in your home, such as clothing, furniture, electronics, and jewelry.'
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/loss-of-use.svg`,
          title: 'Loss of Use',
          text: "If you are ever put out of your home, wholly or partially, because of damages or the destruction of your home due to a covered loss we'll help you cover the cost of living expenses."
        },
        {
          id: 4,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/IdentityTheftResolution.svg`,
          title: 'Identity Theft Resolution',
          text: 'Comprehensive identity theft resolution services, powered by CyberScout, is provided free-of-charge on qualifying policies.'
        }
      ],
      undertitle2: 'Optional coverages and services',
      block2_2: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/OutbuildingsandOtherStructures.svg`,
          title: 'Farm Structures',
          text: 'Protection for the structures on your property used for farming or ranching purposes, such as barns, corrals, pens, fences, and gates.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/tractor.svg`,
          title: 'Farm Equipment, Irrigation Systems, Feed and Seed',
          text: 'Coverage protects hay, grain, fertilizer and chemicals, as well as farm and ranch equipment, such as tractors, farm trailers, and irrigation systems.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/property.svg`,
          title: 'Scheduled Personal Property',
          text: 'Provides additional coverage for valuables like expensive jewelry, cameras, silverware, art collections, antiques, golfing equipment, and musical equipment.'
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/solar-panels.svg`,
          title: 'Solar Panels and Antennas',
          text: "Provides protection to television and radio towers, masts, antennas, outside satellite dishes, and solar panels from damage caused by windstorm, hurricane or hail."
        },
        {
          id: 4,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/equipment.svg`,
          title: 'Equipment Breakdown',
          text: 'Today’s households are often equipped with sophisticated appliances, electronics, and air conditioning systems which would be costly to repair.  This coverage may assist homeowners with unexpected costs associated with repairing or replacing these items when they suffer a direct physical loss.'
        },
//			{
//          id: 5,
//          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/medicalpayment.svg`,
//          title: 'Medical Payments to Others',
//          text: "This coverage provides assistance with medical bills for guests injured while on your property."
//        },
        {
          id: 6,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/product.svg`,
          title: 'Liability',
          text: 'Provides a layer of protection towards bodily injury and property damage claims made by others against you and for which you are legally liable as a result of a covered occurrence. This coverage also includes a no-fault medical payments limit.'
        },

      ]
    },
    block_3: {
      title: 'Coverage personalized to fit your unique needs',
      undertitle: 'Connect with an agent to discuss the various ways a policy with RVOS Insurance may protect your home and belongings.'
    },
    block_4: {
      title: 'Perils insured against*',
      undertitle: 'Our Farm and Ranch policies will help pay to repair damage caused by certain perils, including:',
      block_4_1: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Fire' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Lightning' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Windstorm, Hurricane, and Hail' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Explosion' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Smoke' },
        { id: 5, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Riot and Civil Commotion' },
        { id: 6, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Aircraft and Land Vehicle Damage' },
        { id: 7, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Theft and Vandalism' },
        { id: 8, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Water Discharge' },
        { id: 9, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Glass Breakage' },
        { id: 10, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Weight of Ice, Snow, or Sleet' },
      ]
    },
    block_5: {
      title: 'Common Questions',
      questions: [
        {
          id: 0,
          isOpened: false,
          question: 'Does my policy cover flood damage?',
          answer: `
          <p>
            Standard insurance policies for your home typically do not cover damage caused by floods, earthquakes, and mold. Through the RVOS General Agency, however, we may be able to provide protection for your home and property with a flood insurance policy.
          </p>
          <p>
            If you live in a flood plain, there may also be coverage available to you through the National Flood Insurance Program (NFIP), which is operated by the Federal Emergency Management Agency (FEMA). For more information on government-issued flood insurance, you may reach NFIP at <a href="tel:18004274661">1-800-427-4661</a> or online at <a href="${process.env.REACT_APP_FLOODSMART_URI}" target="_blank">http://www.floodsmart.gov</a>.
          </p>
          <p>
            If you're considering purchasing a flood insurance policy, don't wait until the last minute. There is often a 30-day waiting period before coverage takes effect. Contact your local agent or RVOS General Agency at <a href="tel:18003283379">1-800-328-3379</a> to discuss the options available for your property.
          </p>
          `
        },
        {
          id: 1,
          isOpened: false,
          question: 'How do I estimate the value of my home?',
          answer: `
          <p>
          Estimating the value of your home and the costs associated with its repair or rebuild can be difficult. Deciding whether to insure for Actual Cash Value versus Replacement Cost coverage should be considered. Your agent can help you determine the correct amount of coverage you need.
          </p>
          <p>
            A few of the factors that can assist you to evaluate what it would likely cost to rebuild your home are:
          </p>
          <ul>
            <li>Local construction costs and building costs</li>
            <li>Style of your home (ranch, colonial, contemporary)</li>
            <li>Exterior wall construction (masonry, frame or veneer) and trim</li>
            <li>Type of roof and number of floors (1-3 stories, split level)</li>
            <li>Square footage and number of rooms in your home</li>
            <li>Special features and finishes, such as granite or marble, attached garage, fireplaces,  arched or bay windows, etc.</li>
          </ul>
          <p>
            Checking the latest building codes in your community may be helpful. If your home is severely damaged, you may need to rebuild to comply with local building codes.
          </p>
          `
        }
      ],
      text1: 'Product information listed above is intended for informational purposes only and does not replace or modify definitions, exclusions or any other provision expressly stated in any contracts of insurance. ',
      text2: '*Product information is intended for informational purposes only and does not replace or modify definitions, exclusions, or any other provision expressly stated in any contracts of insurance. Please refer to your actual policy for details related to covered locations and property, covered losses, and coverage limitations.  Not all causes of damage or loss may be covered. Other coverages may be available. Contact your agent for more information.',
      nextLabel: 'Next Product',
      nextPage: {
        title: 'Home Insurance',
        url: '/products/home_owners'
      }
    },
    questionsId: 'FARM_AND_RANCH',
  },
  homeOwners: {
    block_1: {
      rightPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/garden.svg`,
      rightPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/garden.png`,
      leftPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house2.svg`,
      leftPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house2.png`,
      className: 'home_owners',
      widthTitle: 'auto',
      widthUnderTitle: '365px',
      title: 'Home Insurance',
      undertitle: 'Whether you are a first-time homeowner or building your dream home, we offer affordable home insurance you may depend on.'
    },
    block_2: {
      title: 'What is included?',
      undertitle: 'Included Home Insurance coverages',
      block2_1: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/house.svg`,
          title: 'Dwelling',
          text: 'Provides protection for your home.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/other-structures.svg`,
          title: 'Other Structures',
          text: 'Protection for stand-alone structures on your property, such as sheds, carports, and fences.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/personal-property.svg`,
          title: 'Personal Property',
          text: 'Protects the personal items in your home, such as clothing, furniture, electronics, and jewelry.'
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/loss-of-use.svg`,
          title: 'Loss of Use',
          text: "If you are ever put out of your home, wholly or partially, because of damages or the destruction of your home due to a covered loss we'll help you cover the cost of living expenses."
        },
        {
          id: 4,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/./assets/img/products-page/products-block-2-2/product.svg`,
          title: 'Liability',
          text: 'Provides a layer of protection towards bodily injury and property damage claims made by others against you and for which you are legally liable as a result of a covered occurrence. This coverage also includes a no-fault medical payments limit.'
        },
        {
          id: 5,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/IdentityTheftResolution.svg`,
          title: 'Identity Theft Resolution',
          text: 'Comprehensive identity theft resolution services, powered by CyberScout, is provided free-of-charge on qualifying policies.'
        }

      ],
      undertitle2: 'Optional coverages and services',
      block2_2: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/property.svg`,
          title: 'Scheduled Personal Property',
          text: 'Provides additional coverage for valuables like expensive jewelry, cameras, silverware, art collections, antiques, golfing equipment, and musical equipment.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/solar-panels.svg`,
          title: 'Satellite and Antennas',
          text: "Provides protection to television and radio towers, masts, antennas, and outside satellite dishes from damage caused by windstorm, hurricane or hail."
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/equipment.svg`,
          title: 'Equipment Breakdown',
          text: 'Today’s households are often equipped with sophisticated appliances, electronics, and air conditioning systems which would be costly to repair.  This coverage may assist homeowners with unexpected costs associated with repairing or replacing these items when they suffer a direct physical loss.'
        },
 //      {
 //         id: 3,
 //         img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/medicalpayment.svg`,
 //         title: 'Medical Payments to Others',
 //         text: "This coverage provides assistance with medical bills for guests injured while on your property."
 //       }

      ]
    },
    block_3: {
      title: 'Coverage personalized to fit your unique needs',
      undertitle: 'Connect with an agent to discuss the various ways a policy with RVOS Insurance may protect your home and belongings.'
    },
    block_4: {
      title: 'Perils insured against*',
      undertitle: 'Our Home policies will help pay to repair damage caused by certain perils, including:',
      block_4_1: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Fire' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Lightning' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Windstorm, Hurricane, and Hail' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Explosion' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Smoke' },
        { id: 5, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Riot and Civil Commotion' },
        { id: 6, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Aircraft and Land Vehicle Damage' },
        { id: 7, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Theft and Vandalism' },
        { id: 8, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Water Discharge' },
        { id: 9, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Glass Breakage' },
        { id: 10, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Collapse' },
        { id: 11, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Weight of Ice, Snow, or Sleet' },
      ]
    },
    block_5: {
      title: 'Common Questions',
      questions: [
        {
          id: 0,
          isOpened: false,
          question: 'Does my policy cover flood damage?',
          answer: `
          <p>
            Standard insurance policies for your home typically do not cover damage caused by floods, earthquakes, and mold. Through the RVOS General Agency, however, we may be able to provide protection for your home and property with a flood insurance policy.
          </p>
          <p>
            If you live in a flood plain, there may also be coverage available to you through the National Flood Insurance Program (NFIP), which is operated by the Federal Emergency Management Agency (FEMA). For more information on government-issued flood insurance, you may reach NFIP at <a href="tel:18004274661">1-800-427-4661</a> or online at <a href="${process.env.REACT_APP_FLOODSMART_URI}" target="_blank">http://www.floodsmart.gov</a>.
          </p>
          <p>
            If you're considering purchasing a flood insurance policy, don't wait until the last minute. There is often a 30-day waiting period before coverage takes effect. Contact your local agent or RVOS General Agency at <a href="tel:18003283379">1-800-328-3379</a> to discuss the options available for your property.
          </p>
          `
        },
        {
          id: 1,
          isOpened: false,
          question: 'How do I estimate the value of my home?',
          answer: `
          <p>
          Estimating the value of your home and the costs associated with its repair or rebuild can be difficult. Deciding whether to insure for Actual Cash Value versus Replacement Cost coverage should be considered. Your agent can help you determine the correct amount of coverage you need.
          </p>
          <p>
            A few of the factors that can assist you to evaluate what it would likely cost to rebuild your home are:
          </p>
          <ul>
            <li>Local construction costs and building costs</li>
            <li>Style of your home (ranch, colonial, contemporary)</li>
            <li>Exterior wall construction (masonry, frame or veneer) and trim</li>
            <li>Type of roof and number of floors (1-3 stories, split level)</li>
            <li>Square footage and number of rooms in your home</li>
            <li>Special features and finishes, such as granite or marble, attached garage, fireplaces,  arched or bay windows, etc.</li>
          </ul>
          <p>
            Checking the latest building codes in your community may be helpful. If your home is severely damaged, you may need to rebuild to comply with local building codes.
          </p>
          `
        }
      ],
      text1: 'Product information listed above is intended for informational purposes only and does not replace or modify definitions, exclusions or any other provision expressly stated in any contracts of insurance. ',
      text2: '*Product information is intended for informational purposes only and does not replace or modify definitions, exclusions, or any other provision expressly stated in any contracts of insurance. Please refer to your actual policy for details related to covered locations and property, covered losses, and coverage limitations.  Not all causes of damage or loss may be covered. Other coverages may be available. Contact your agent for more information.',
      previousLabel: 'Previous Product',
      previousPage: {
        title: 'Farm and Ranch',
        url: '/products/farm_and_ranch'
      },
      nextLabel: 'Next Product',
      nextPage: {
        title: 'Manufactured and Mobile Home',
        url: '/products/manufactured_and_mobile_home'
      }
    },
    questionsId: 'HOME_OWNERS',
  },
  manufactured: {
    block_1: {
      rightPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house4.svg`,
      rightPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house4.png`,
      leftPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house3.svg`,
      leftPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house3.png`,
      className:'manufactured',
      widthTitle: '862px',
      widthUnderTitle: '298px',
      title: 'Manufactured and Mobile Home Insurance',
      undertitle: 'Coverage that meets the unique needs of your home and personal property.'
    },
    block_2: {
      title: 'What is included?',
      undertitle: 'Included Manufactured and Mobile Home Insurance coverages',
      block2_1: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/house.svg`,
          title: 'Dwelling',
          text: 'Provides protection for your home.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/other-structures.svg`,
          title: 'Other Structures',
          text: 'Protection for stand-alone structures on your property, such as sheds, carports, and fences.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/personal-property.svg`,
          title: 'Personal Property',
          text: 'Protects the personal items in your home, such as clothing, furniture, electronics, and jewelry.'
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/loss-of-use.svg`,
          title: 'Loss of Use',
          text: "If you are ever put out of your home, wholly or partially, because of damages or the destruction of your home due to a covered loss we'll help you cover the cost of living expenses."
        },
        {
          id: 4,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/IdentityTheftResolution.svg`,
          title: 'Identity Theft Resolution',
          text: 'Comprehensive identity theft resolution services, powered by CyberScout, is provided free-of-charge on qualifying policies.'
        }
      ],
      undertitle2: 'Optional coverages and services',
      block2_2: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/OutbuildingsandOtherStructures.svg`,
          title: 'Farm Structures',
          text: 'Protection for the structures on your property used for farming or ranching purposes, such as barns, corrals, pens, fences, and gates.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/tractor.svg`,
          title: 'Farm Equipment, Irrigation Systems, Feed and Seed',
          text: 'Coverage protects hay, grain, fertilizer and chemicals, as well as farm and ranch equipment, such as tractors, farm trailers, and irrigation systems.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/property.svg`,
          title: 'Scheduled Personal Property',
          text: 'Provides additional coverage for valuables like expensive jewelry, cameras, silverware, art collections, antiques, golfing equipment, and musical equipment.'
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/solar-panels.svg`,
          title: 'Solar Panels and Antennas',
          text: "Provides protection to television and radio towers, masts, antennas, outside satellite dishes, and solar panels from damage caused by windstorm, hurricane or hail."
        },
        {
          id: 4,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/equipment.svg`,
          title: 'Equipment Breakdown',
          text: 'Today’s households are often equipped with sophisticated appliances, electronics, and air conditioning systems which would be costly to repair.  This coverage may assist homeowners with unexpected costs associated with repairing or replacing these items when they suffer a direct physical loss.'
        },
//        {
//          id: 5,
//          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/medicalpayment.svg`,
//          title: 'Medical Payments to Others',
//          text: "This coverage provides assistance with medical bills for guests injured while on your property."
//        },
        {
          id: 6,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/product.svg`,
          title: 'Liability',
          text: 'Provides a layer of protection towards bodily injury and property damage claims made by others against you and for which you are legally liable as a result of a covered occurrence. This coverage also includes a no-fault medical payments limit.'
        }
      ]
    },
    block_3: {
      title: 'Coverage personalized to fit your unique needs',
      undertitle: 'Connect with an agent to discuss the various ways a policy with RVOS Insurance may protect your home and belongings.'
    },
    block_4: {
      title: 'Perils insured against*',
      undertitle: 'Our Manufactured and Mobile Home policies will help pay to repair damage caused by certain perils, including:',
      block_4_1: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Fire' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Lightning' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Windstorm, Hurricane, and Hail' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Explosion' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Smoke' },
        { id: 5, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Riot and Civil Commotion' },
        { id: 6, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Aircraft and Land Vehicle Damage' },
        { id: 7, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Theft and Vandalism' },
        { id: 8, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Water Discharge' },
        { id: 9, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Glass Breakage' },
        // { id: 10, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Collapse' },
        { id: 11, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Weight of Ice, Snow, or Sleet' }
      ]
    },
    block_5: {
      title: 'Common Questions',
      questions: [
        {
          id: 0,
          isOpened: false,
          question: 'Does my policy cover flood damage?',
          answer: `
          <p>
            Standard insurance policies for your home typically do not cover damage caused by floods, earthquakes, and mold. Through the RVOS General Agency, however, we may be able to provide protection for your home and property with a flood insurance policy.
          </p>
          <p>
            If you live in a flood plain, there may also be coverage available to you through the National Flood Insurance Program (NFIP), which is operated by the Federal Emergency Management Agency (FEMA). For more information on government-issued flood insurance, you may reach NFIP at <a href="tel:18004274661">1-800-427-4661</a> or online at <a href="${process.env.REACT_APP_FLOODSMART_URI}" target="_blank">http://www.floodsmart.gov</a>.
          </p>
          <p>
            If you're considering purchasing a flood insurance policy, don't wait until the last minute. There is often a 30-day waiting period before coverage takes effect. Contact your local agent or RVOS General Agency at <a href="tel:18003283379">1-800-328-3379</a> to discuss the options available for your property.
          </p>
          `
        },
        {
          id: 1,
          isOpened: false,
          question: 'How do I estimate the value of my home?',
          answer: `
          <p>
          Estimating the value of your home and the costs associated with its repair or rebuild can be difficult. Deciding whether to insure for Actual Cash Value versus Replacement Cost coverage should be considered. Your agent can help you determine the correct amount of coverage you need.
          </p>
          <p>
            A few of the factors that can assist you to evaluate what it would likely cost to rebuild your home are:
          </p>
          <ul>
            <li>Local construction costs and building costs</li>
            <li>Style of your home (ranch, colonial, contemporary)</li>
            <li>Exterior wall construction (masonry, frame or veneer) and trim</li>
            <li>Type of roof and number of floors (1-3 stories, split level)</li>
            <li>Square footage and number of rooms in your home</li>
            <li>Special features and finishes, such as granite or marble, attached garage, fireplaces,  arched or bay windows, etc.</li>
          </ul>
          <p>
            Checking the latest building codes in your community may be helpful. If your home is severely damaged, you may need to rebuild to comply with local building codes.
          </p>
          `
        }
      ],
      text1: 'Product information listed above is intended for informational purposes only and does not replace or modify definitions, exclusions or any other provision expressly stated in any contracts of insurance. ',
      text2: '*Product information is intended for informational purposes only and does not replace or modify definitions, exclusions, or any other provision expressly stated in any contracts of insurance. Please refer to your actual policy for details related to covered locations and property, covered losses, and coverage limitations.  Not all causes of damage or loss may be covered. Other coverages may be available. Contact your agent for more information.',
      previousLabel: 'Previous Product',
      previousPage: {
        title: 'Home Insurance',
        url: '/products/home_owners'
      },
      nextLabel: 'Next Product',
      nextPage: {
        title: 'Landlord',
        url: '/products/landlord'
      }
    },
    questionsId: 'MANUFACTURED',
  },
  landlord: {
    block_1: {
      rightPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house6.svg`,
      rightPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house6.png`,
      leftPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house5.svg`,
      leftPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/house5.png`,
      className: 'landlord',
      widthTitle: 'auto',
      widthUnderTitle: '442px',
      title: 'Landlord Insurance',
      undertitle: 'You need a policy to protect you when renting your property to others and we have a policy to do just that.'
    },
    block_2: {
      title: 'What is included?',
      undertitle: 'Landlord Insurance coverages',
      block2_1: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/house.svg`,
          title: 'Dwelling',
          text: 'Provides protection for the home.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/other-structures.svg`,
          title: 'Other Structures',
          text: 'Protection for stand-alone structures on the property, such as sheds, carports, and fences.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/personal-property.svg`,
          title: 'Personal Property',
          text: 'Protects the personal items in the home, such as clothing, furniture, electronics, and jewelry.'
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/buildings.svg`,
          title: 'Building',
          text: 'Protection for your physical building.'
        },
      ],
      undertitle2: 'Optional coverages and services',
      block2_2: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/OutbuildingsandOtherStructures.svg`,
          title: 'Farm Structures',
          text: 'Protection for the structures on your property used for farming or ranching purposes, such as barns, corrals, pens, fences, and gates.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/tractor.svg`,
          title: 'Farm Equipment, Irrigation Systems, Feed and Seed',
          text: 'Coverage protects hay, grain, fertilizer and chemicals, as well as farm and ranch equipment, such as tractors, farm trailers, and irrigation systems.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/solar-panels.svg`,
          title: 'Solar Panels and Antennas',
          text: "Provides protection to television and radio towers, masts, antennas, outside satellite dishes, and solar panels from damage caused by windstorm, hurricane or hail."
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/equipment.svg`,
          title: 'Equipment Breakdown',
          text: 'Today’s households are often equipped with sophisticated appliances, electronics, and air conditioning systems which would be costly to repair.  This coverage may assist homeowners with unexpected costs associated with repairing or replacing these items when they suffer a direct physical loss.'
        },
//        {
//          id: 4,
//          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/medicalpayment.svg`,
//          title: 'Medical Payments to Others',
//          text: "This coverage provides assistance with medical bills for guests injured while on your property."
//        },
        {
          id: 5,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/product.svg`,
          title: 'Liability',
          text: 'Provides a layer of protection towards bodily injury and property damage claims made by others against you and for which you are legally liable as a result of a covered occurrence. This coverage also includes a no-fault medical payments limit.'
        }
      ]
    },
    block_3: {
      title: 'Coverage personalized to fit your unique needs',
      undertitle: 'Connect with an agent to discuss the various ways a policy with RVOS Insurance may protect your home and belongings.'
    },
    block_4: {
      title: 'Perils insured against*',
      undertitle: 'Our Landlord policies will help pay to repair damage caused by certain perils, including:',
      block_4_1: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Fire' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Lightning' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Windstorm, Hurricane, and Hail' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Explosion' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Smoke' },
        { id: 5, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Riot and Civil Commotion' },
        { id: 6, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Aircraft and Land Vehicle Damage' },
        { id: 7, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Theft and Vandalism' },
        { id: 8, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Water Discharge' },
        { id: 9, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Weight of Ice, Snow, or Sleet' }
      ]
    },
    block_5: {
      title: 'Common Questions',
      questions: [
        {
          id: 0,
          isOpened: false,
          question: 'Does my policy cover flood damage?',
          answer:
              `
          <p>
            Standard insurance policies for your home typically do not cover damage caused by floods, earthquakes, and mold. Through the RVOS General Agency, however, we may be able to provide protection for your home and property with a flood insurance policy.
          </p>
          <p>
            If you live in a flood plain, there may also be coverage available to you through the National Flood Insurance Program (NFIP), which is operated by the Federal Emergency Management Agency (FEMA). For more information on government-issued flood insurance, you may reach NFIP at <a href="tel:18004274661">1-800-427-4661</a> or online at <a href="${process.env.REACT_APP_FLOODSMART_URI}" target="_blank">http://www.floodsmart.gov</a>.
          </p>
          <p>
            If you're considering purchasing a flood insurance policy, don't wait until the last minute. There is often a 30-day waiting period before coverage takes effect. Contact your local agent or RVOS General Agency at <a href="tel:18003283379">1-800-328-3379</a> to discuss the options available for your property.
          </p>
          `
        }
      ],
      text1: 'Product information listed above is intended for informational purposes only and does not replace or modify definitions, exclusions or any other provision expressly stated in any contracts of insurance. ',
      text2: '*Product information is intended for informational purposes only and does not replace or modify definitions, exclusions, or any other provision expressly stated in any contracts of insurance. Please refer to your actual policy for details related to covered locations and property, covered losses, and coverage limitations.  Not all causes of damage or loss may be covered. Other coverages may be available. Contact your agent for more information.',
      previousLabel: 'Previous Product',
      previousPage: {
        title: 'Manufactured and Mobile Home',
        url: '/products/manufactured_and_mobile_home'
      },
      nextLabel: 'Next Product',
      nextPage: {
        title: 'Church and Organization',
        url: '/products/organization'
      }
    },
    questionsId: 'LANDLORD',
  },
  organization: {
    block_1: {
      rightPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/church.svg`,
      rightPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/church.png`,
      leftPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/park.svg`,
      leftPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/park.png`,
      className: 'organization',
      widthTitle: 'auto',
      widthUnderTitle: '550px',
      title: 'Organization Insurance',
      undertitle: "RVOS Insurance understands the importance of community to Texans. That's why we are committed to providing affordable protection for the places where you meet - churches, halls, and community centers."},
    block_2: {
      title: 'What is included?',
      undertitle: 'Included Organization Insurance coverages',
      block2_1: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/buildings.svg`,
          title: 'Building',
          text: 'Protection for your physical building.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/other-structures.svg`,
          title: 'Other Structures',
          text: 'Protection for stand-alone structures on your property, such as sheds, carports, and fences.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/personal-property.svg`,
          title: 'Personal Property',
          text: 'Protects the personal property belonging to your organization.'
        }

      ],
      undertitle2: 'Optional coverages and services',
      block2_2: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-2/solar-panels.svg`,
          title: 'Satellite and Antennas',
          text: "Provides protection to television and radio towers, masts, antennas, and outside satellite dishes from damage caused by windstorm, hurricane or hail."
        },
//        {
//          id: 1,
//          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/medicalpayment.svg`,
//          title: 'Medical Payments to Others',
//          text: "This coverage provides assistance with medical bills for guests injured while on your property."
//        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/budka.svg`,
          title: 'Commercial Liability',
          text: "Protects your property if you become obligated to pay for losses arising from bodily injury or property damage on your business property. This coverage also includes a no-fault medical payments limit."
        }
      ]
    },
    block_3: {
      title: 'Coverage personalized to fit your unique needs',
      undertitle: 'Connect with an agent to discuss the various ways a policy with RVOS Insurance may protect your home and belongings.'
    },
    block_4: {
      title: 'Perils insured against*',
      undertitle: 'Our Organizational Property policies provide protection for damage caused by certain perils, including:',
      block_4_1: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Fire' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Lightning' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Windstorm, Hurricane, and Hail' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Explosion' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Smoke' },
        { id: 5, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Riot and Civil Commotion' },
        { id: 6, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Aircraft and Land Vehicle Damage' },
        { id: 7, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Theft and Vandalism' },
        { id: 8, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Water Discharge' },
        // { id: 9, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Collapse' },
        { id: 10, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Weight of Ice, Snow, or Sleet' }
      ]
    },
    block_5: {
      title: 'Common Questions',
      questions: [
        {
          id: 0,
          isOpened: false,
          question: 'Does my policy cover flood damage?',
          answer: `
          <p>
            Standard insurance policies for your home typically do not cover damage caused by floods, earthquakes, and mold. Through the RVOS General Agency, however, we may be able to provide protection for your home and property with a flood insurance policy.
          </p>
          <p>
            If you live in a flood plain, there may also be coverage available to you through the National Flood Insurance Program (NFIP), which is operated by the Federal Emergency Management Agency (FEMA). For more information on government-issued flood insurance, you may reach NFIP at <a href="tel:18004274661">1-800-427-4661</a> or online at <a href="${process.env.REACT_APP_FLOODSMART_URI}" target="_blank">http://www.floodsmart.gov</a>.
          </p>
          <p>
            If you're considering purchasing a flood insurance policy, don't wait until the last minute. There is often a 30-day waiting period before coverage takes effect. Contact your local agent or RVOS General Agency at <a href="tel:18003283379">1-800-328-3379</a> to discuss the options available for your property.
          </p>
          `
        },
      ],
      text1: 'Product information listed above is intended for informational purposes only and does not replace or modify definitions, exclusions or any other provision expressly stated in any contracts of insurance. ',
      text2: '*Product information is intended for informational purposes only and does not replace or modify definitions, exclusions, or any other provision expressly stated in any contracts of insurance. Please refer to your actual policy for details related to covered locations and property, covered losses, and coverage limitations.  Not all causes of damage or loss may be covered. Other coverages may be available. Contact your agent for more information.',
      previousLabel: 'Previous Product',
      previousPage: {
        title: 'Landlord',
        url: '/products/landlord'
      },
      nextLabel: 'Next Product',
      nextPage: {
        title: 'Commercial',
        url: '/products/commercial'
      }
    },
    questionsId: 'ORGANIZATION',
  },
  commercial: {
    block_1: {
      rightPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/holupa.svg`,
      rightPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/holupa.png`,
      leftPicture: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/office.svg`,
      leftPictureLow: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-1/office.png`,
      className: 'commercial',
      widthTitle: 'auto',
      widthUnderTitle: '290px',
      title: 'Commercial Insurance',
      undertitle: "Designed to fit your business's need and budget."},
    block_2: {
      title: 'Available coverages',
      undertitle: null,
      block2_1: null,
      undertitle2: null,
      block2_2: [
        {
          id: 0,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/buildings.svg`,
          title: 'Building',
          text: 'Protection for your physical building.'
        },
        {
          id: 1,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/content.svg`,
          title: 'Contents and Stock',
          text: 'Protection for your equipment, furniture, and stock.'
        },
        {
          id: 2,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/personal-property.svg`,
          title: 'Property in the Open',
          text: 'Protection for outdoor items such as fencing, outdoor signs, and storage sheds.'
        },
        {
          id: 3,
          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/budka.svg`,
          title: 'Commercial Liability',
          text: "Protects your property if you become obligated to pay for losses arising from bodily injury or property damage on your business property. This coverage also includes a no-fault medical payments limit."
        },
//        {
//          id: 4,
//          img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-2-1/medicalpayment.svg`,
//          title: 'Medical Payments to Others',
//          text: "This coverage provides assistance with medical bills for guests injured while on your business property."
//        }
      ]
    },
    block_3: {
      title: 'Coverage personalized to fit your unique needs',
      undertitle: 'Connect with an agent to discuss the various ways a policy with RVOS Insurance may protect your home and belongings.'
    },
    block_4: {
      title: 'Perils insured against*',
      undertitle: 'Our Commercial policies will help pay to repair damage caused by certain perils, including:',
      block_4_1: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Fire' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Lightning' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Windstorm, Hurricane, and Hail' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Explosion' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Smoke' },
        { id: 5, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Riot and Civil Commotion' },
        { id: 6, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Aircraft and Land Vehicle Damage' },
        { id: 7, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Theft and Vandalism' },
        { id: 8, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Accidental Water Discharge' },
        { id: 9, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Collapse' },
        { id: 10, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/products-page/products-block-4/product.png`, text: 'Weight of Ice, Snow, or Sleet' }
      ]
    },
    block_5: {
      title: 'Common Questions',
      questions: [
        {
          id: 0,
          isOpened: false,
          question: 'Does my policy cover flood damage?',
          answer:
              `
          <p>
            Standard insurance policies for your home typically do not cover damage caused by floods, earthquakes, and mold. Through the RVOS General Agency, however, we may be able to provide protection for your home and property with a flood insurance policy.
          </p>
          <p>
            If you live in a flood plain, there may also be coverage available to you through the National Flood Insurance Program (NFIP), which is operated by the Federal Emergency Management Agency (FEMA). For more information on government-issued flood insurance, you may reach NFIP at <a href="tel:18004274661">1-800-427-4661</a> or online at <a href="${process.env.REACT_APP_FLOODSMART_URI}" target="_blank">http://www.floodsmart.gov</a>.
          </p>
          <p>
            If you're considering purchasing a flood insurance policy, don't wait until the last minute. There is often a 30-day waiting period before coverage takes effect. Contact your local agent or RVOS General Agency at <a href="tel:18003283379">1-800-328-3379</a> to discuss the options available for your property.
          </p>
          `
        }
      ],
      text1: 'Product information listed above is intended for informational purposes only and does not replace or modify definitions, exclusions or any other provision expressly stated in any contracts of insurance. ',
      text2: '*Product information is intended for informational purposes only and does not replace or modify definitions, exclusions, or any other provision expressly stated in any contracts of insurance. Please refer to your actual policy for details related to covered locations and property, covered losses, and coverage limitations.  Not all causes of damage or loss may be covered. Other coverages may be available. Contact your agent for more information.',
      previousLabel: 'Previous Product',
      previousPage: {
        title: 'Church and Organization',
        url: '/products/organization'
      },
    },
    questionsId: 'COMMERCIAL',
  }
}
